// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warp[data-v-2f3c0573] .el-form-item {\n  margin-bottom: 0 !important;\n}\n.selectLabel[data-v-2f3c0573]  .el-input__inner {\n  height: 28px !important;\n  line-height: 28px !important;\n  font-weight: bold;\n  text-align: left;\n  margin-bottom: 5px;\n}\n.detailLabel[data-v-2f3c0573] {\n  font-size: 14px;\n  font-weight: 700;\n  color: #909399;\n  margin-right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
